module.exports = __webpack_public_path__ + "static/media/random-cat.1189214c.png";